<template>
  <el-container>
    <el-header>
      <nav>
        <router-link to="/">视频字幕添加</router-link>
        <!-- |<router-link to="/about">About</router-link> -->
      </nav>
    </el-header>
    <el-main>
      <router-view />
    </el-main>
    <el-footer>内测中</el-footer>
  </el-container>
</template>

<style lang="less">
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

nav {
  padding: 30px;

  a {
    font-weight: bold;
    color: #2c3e50;

    &.router-link-exact-active {
      color: #42b983;
    }
  }
}
</style>
